// Meta Pixel Utility
const PIXEL_ID = '856514407212735'

type PixelEvent = 'PageView' | 'InitiateCheckout' | 'Purchase' | 'ViewContent'

interface EventData {
  value?: number
  currency?: string
  content_name?: string
  content_ids?: string[]
  content_type?: string
}

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export const initPixel = () => {
  // Prevent duplicate initialization
  if (window.fbq) {
    // Already initialized, just track PageView
    window.fbq('track', 'PageView')
    return
  }

  // Create fbq function
  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  // Load the Facebook pixel script safely
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  // Initialize pixel and track PageView
  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')

  console.log(`Meta Pixel Initialized: ${PIXEL_ID}`)
}

export const trackEvent = (eventName: PixelEvent, data?: EventData) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, data)
    console.log(`Pixel Event: ${eventName}`, data)
  }
}
